import styled from 'styled-components';
import { MAIN_BLUE } from '../../styles/Colors';
import { below } from '../../utils/Breakpoints';

export const StyledButton = styled.button`
  width: ${(props) => props.width || '220px'};
  height: ${(props) => props.height || '80px'};
  font-size: ${(props) => props.fontSize || '22px'};
  font-weight: 900;
  border: none;
  outline: none;
  border-radius: ${(props) => props.radius || '810px'};
  color: ${(props) => props.color || MAIN_BLUE};
  background-color: ${(props) => props.background};
  transition: 0.2;
  cursor: pointer;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  &:hover {
    background-color: ${MAIN_BLUE};
    filter: brightness(1.3);
    transition: 0.2;
  }
  ${below.med`
	 	width:${'70%'}; 
		 height:15%;
	  `}
`;
  